import { __extends } from "tslib";
import { Subscriber } from '../Subscriber';
import { observeNotification, COMPLETE_NOTIFICATION, nextNotification, errorNotification } from '../Notification';
import { lift } from '../util/lift';
export function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function observeOnOperatorFunction(source) {
        return lift(source, new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        observeNotification(notification, destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, {
            notification: notification,
            destination: destination,
        }));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(nextNotification(value));
    };
    ObserveOnSubscriber.prototype._error = function (error) {
        this.scheduleMessage(errorNotification(error));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(COMPLETE_NOTIFICATION);
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(Subscriber));
//# sourceMappingURL=observeOn.js.map